import { makeStyles } from '@mui/styles';
import { muiTheme } from '@tassat/payments-themes';

export default makeStyles((theme: typeof muiTheme) => ({
    root: {
        padding: '0',
        textTransform: 'none' as 'none',
        borderRadius: '5px'
    },
    textContainer: { padding: '.3rem .5rem' },
    iconContainer: {
        height: '38px',
        width: '38px'
    },
    iconButton: {
        border: 'none' as 'none',
        backgroundColor: 'transparent',
        '&:hover': { backgroundColor: theme?.app?.applicationColors.enumColors.offWhite || '#f2f2f2' },
        '&:disabled': { backgroundColor: theme?.app?.applicationColors.enumColors.offWhite || '#e4e4e4' }
    },
    primary: {
        color: theme?.app?.applicationColors.enumColors.white || '#fff',
        backgroundColor: theme?.app?.clientTheme.colors.primaryColor || '#375073',
        border: `1px solid ${theme?.app?.applicationColors.enumColors.white || '#fff'}`,
        '&:hover': { backgroundColor: theme?.app?.clientTheme.colors.buttons.primaryColorLight || 'rgb(0, 155, 223)' },
        '&:disabled': { backgroundColor: theme?.app?.applicationColors.enumColors.grey || '#8f98a6' }
    },
    muted: {
        color: theme?.app?.clientTheme.colors.primaryColor || '#375073',
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary || '#fff',
        border: `1px solid ${theme?.app?.applicationColors.enumColors.greyLighter || '#C3CAD5'}`,
        '&:hover': { backgroundColor: theme?.app?.applicationColors.enumColors.offWhite || '#f2f2f2' },
        '&:disabled': {
            backgroundColor: theme?.app?.applicationColors.enumColors.offWhite || '#f1f1f1e3',
            border: `1px solid ${theme?.app?.applicationColors.enumColors.greyLight || '#a0a0a0'}`
        }
    },
    icon: {
        width: '20px',
        height: '20px'
    },
    actionInProgressIcon: { color: theme?.app?.clientTheme.colors.primaryColor || '#375073' },
    tooltip: { top: '-10px !important' }
}));